import XLSX from "../../__snowpack__/pkg/xlsx.js";
export async function parseFileToJson(file) {
  return new Promise((resolve, reject) => {
    let fileTypeList = file.name.split(".");
    const type = fileTypeList[fileTypeList.length - 1];
    if (!["xlsx", "xls"].includes(type)) {
      reject({msg: "\u4EC5\u652F\u6301Excel\u6587\u4EF6\u683C\u5F0F"});
    }
    let sheet = null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const data = e.currentTarget.result;
      const workbook = XLSX.read(data, {type: "binary"});
      const sheet2 = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      resolve(sheet2);
    };
    fileReader.readAsBinaryString(file);
  });
}
export function downloadExcel({
  colNameList,
  dataList,
  filename,
  sheetName
}) {
  var data = [colNameList, ...dataList];
  var wb = XLSX.utils.book_new(), ws = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
}
